// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2htaz","content":"styles_content__2opCC","row":"styles_row__3vOvW","footer":"styles_footer__1q4qW","phraseLength":"styles_phraseLength__3fkyY"};